<template>
    <section>
        <div class="w-100 d-flex feature justify-content-between align-items-center p-2 mb-2">
            <div class="title">
                <h3>Personal Application Settings</h3>
            </div>
            <div class="actions d-flex">
                <el-button @click="clearLocalStorage" type="primary">Clear Local Storage</el-button>
            </div>
        </div>
        <hr/>
        <el-form :model="settings" ref="ruleForm" label-width="450px">
            <el-form-item label="Application View" prop="dashboard">
                <el-select v-model="settings.application_view" placeholder="Application View">
                    <el-option label="V1" value="v1"></el-option>
                    <el-option label="V2" value="v2"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Show Email in Templates" prop="show_email">
                <el-select v-model="settings.show_broker_email_in_templates" placeholder="Show Email in Templates">
                    <el-option label="Tenant Setting" value="global"></el-option>
                    <el-option label="Yes" value="yes"></el-option>
                    <el-option label="No" value="no"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Show Phone in Templates" prop="show_phone">
                <el-select v-model="settings.show_broker_phone_in_templates" placeholder="Show Phone in Templates">
                    <el-option label="Tenant Setting" value="global"></el-option>
                    <el-option label="Yes" value="yes"></el-option>
                    <el-option label="No" value="no"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Disable Mouse Drag on Application Card View" prop="disable_card_view_dragging">
                <el-select v-model="settings.disable_card_view_dragging">
                    <el-option label="No" value="no"></el-option>
                    <el-option label="Yes" value="yes"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Disable Hover on Application Card View" prop="disable_card_view_hover">
                <el-select v-model="settings.disable_card_view_hover">
                    <el-option label="No" value="no"></el-option>
                    <el-option label="Yes" value="yes"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Expand All Application Tabs" prop="expand_application_tabs">
                <el-select v-model="settings.expand_application_tabs">
                    <el-option label="No" value="no"></el-option>
                    <el-option label="Yes" value="yes"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Show Assets And Liabilities Full List?" prop="show_assets_and_liabilities_full_lists">
                <el-select v-model="settings.show_assets_and_liabilities_full_lists">
                    <el-option label="No" value="no"></el-option>
                    <el-option label="Yes" value="yes"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Show Expenses Full Lists?" prop="show_expenses_full_lists">
                <el-select v-model="settings.show_expenses_full_lists">
                    <el-option label="No" value="no"></el-option>
                    <el-option label="Yes" value="yes"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Remove Filter" prop="remove_filter">
                <el-select v-model="settings.show_expenses_full_lists">
                    <el-option label="No" value="no"></el-option>
                    <el-option label="Yes" value="yes"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Personal Access Token" prop="application_key">
                <el-input :value="api_key" readonly>
                    <el-button slot="append" @click="generateApplicationKey()">Generate Key</el-button>
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="setSettings()">Save settings</el-button>
            </el-form-item>
        </el-form>
    </section>
</template>

<script>
import {Message} from "element-ui"

export default {
    name: "UserProfileSettings",
    components: {},
    props: ["tokenInitial", "userSettings", "user"],
    data() {
        return {
            settings: {
                application_view: "",
                show_broker_email_in_templates: "",
                show_broker_phone_in_templates: "",
                disable_card_view_dragging: "",
                disable_card_view_hover: "",
                expand_application_tabs: "",
                show_assets_and_liabilities_full_lists: "",
                show_expenses_full_lists: "",
            },
            api_key: "",
        }
    },
    computed: {},
    watch: {},
    mounted() {
        let application_view = _.get(this.userSettings, "application_view", "v1")
        this.settings.application_view = application_view != "v1" ? application_view : "v1"
        this.settings.show_broker_email_in_templates = _.get(this.userSettings, "show_broker_email_in_templates", "global")
        this.settings.show_broker_phone_in_templates = _.get(this.userSettings, "show_broker_phone_in_templates", "global")
        this.settings.disable_card_view_dragging = _.get(this.userSettings, "disable_card_view_dragging", "no")
        this.settings.disable_card_view_hover = _.get(this.userSettings, "disable_card_view_hover", "no")
        this.settings.expand_application_tabs = _.get(this.userSettings, "expand_application_tabs", "yes")
        this.settings.show_assets_and_liabilities_full_lists = _.get(this.userSettings, "show_assets_and_liabilities_full_lists", "yes")
        this.settings.show_expenses_full_lists = _.get(this.userSettings, "show_expenses_full_lists", "yes")
        this.api_key = _.get(this.user, "personal_access_token", "")
    },
    updated() {
    },
    activated() {
    },
    methods: {
        clearLocalStorage() {
            window.localStorage.clear()
            swal({
                title: "Success!",
                type: "success",
                text: "You have cleared your local storage.",
            })
        },
        apiToken() {
            return {
                headers: {Authorization: `Bearer ${this.tokenInitial}`},
            }
        },
        generateApplicationKey() {
            axios
                .put("/api/v2/user-settings/generate-key", [], this.apiToken())
                .then((res) => {
                    this.api_key = res.data.key
                    Message({
                        type: "success",
                        message: res.data.message,
                    })
                })
                .catch((err) => {
                    Message({
                        type: "error",
                        message: "Unable to update settings",
                    })
                })
        },
        setSettings() {
            axios
                .put("/api/v2/user-settings", this.settings, this.apiToken())
                .then((res) => {
                    Message({
                        type: "success",
                        message: "Settings Updated",
                    })
                })
                .catch((err) => {
                    Message({
                        type: "error",
                        message: "Unable to update settings",
                    })
                })
        },
    },
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
